import(/* webpackMode: "eager", webpackExports: ["ReviewsContent"] */ "/var/www/azia_frontv2_green/src/app/reviews/reviews-content.tsx");
